import React from 'react'
import { Ticket } from '../../../types/modules/ticket.type'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import DateTimeText from '../../ui/DateTimeText'

type Props ={
    tickets:Ticket[]
}

function TicketsListWrapper({tickets}:Props) {
  const {t} = useTranslation();
  return (
    <div className="space-y-3">
            {tickets.map((ticket) => (
              <Link
                key={ticket.id}
                to={`/store/tickets/${ticket.id}`}
                className="block border rounded-lg p-4 hover:shadow-sm hover:bg-gray-50 transition-shadow"
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-900 text-sm sm:text-base">{ticket.subject}</h3>
                    <p className="text-xs text-gray-500 mt-1 line-clamp-2">{ticket.description}</p>
                  </div>
                  <span
                    className={`text-xs font-semibold px-2 py-1 rounded-full capitalize ${
                      ticket.status === "pending"
                        ? "bg-yellow-100 text-yellow-800"
                        : ticket.status === "inProgress"
                        ? "bg-blue-100 text-blue-800"
                        : ticket.status === "rejected"
                        ? "bg-red-100 text-red-800"
                        : "bg-green-100 text-green-800"
                    }`}
                  >
                    {t(ticket.status)}
                  </span>
                </div>

                <div className="flex flex-col mt-2 text-xs text-DarkGrey3 space-y-1">
                  <span className='capitalize'>{t("created_at")}: <DateTimeText date={ticket.createdAt} /></span>
                  <span className=' capitalize'>{t("last_update")}: <DateTimeText date={ticket.updatedAt} /></span>
                  {ticket.closedAt && <span className=' capitalize'>{t('closed_at')}: <DateTimeText date={ticket.closedAt} /></span>}
                  {ticket.rating !== null && <span>⭐ Rating: {ticket.rating}</span>}
                </div>

              </Link>
            ))}
          </div>
  )
}

export default TicketsListWrapper